import { useQuery } from 'react-query';
import useAxiosInstance from '../useXdmAxiosInstance';
import { getXdmEntityAllData } from '../../services/XdmService';
import { XdmEntityObject } from '../../models';

export default function useGetXdmEntityDataQuery(entityName: string) {
  const { axios } = useAxiosInstance();

  return useQuery<XdmEntityObject[]>([entityName], async () =>
    getXdmEntityAllData(axios, entityName)
  );
}
